<template>
    <div class="card mt-4">
        <div class="card-body">
            <div class="change-product-seller">
                <h5 class="">Change Ownership</h5>
                <input type="text" class="form-control" v-model="customer_email" placeholder="Customer email" />
                <button class="btn btn-primary rounded mt-3" @click.prevent="assignOwnership()">Assign</button>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';

export default {
    props: ['product_detail'],
    data() {
        return {
            customer_email: '',
            customerSuggestions: [
                {
                    data: []
                }
            ]
        };
    },
    methods: {
        async assignOwnership() {
            if (!this.customer_email.trim()) {
                this.$toasted.global.error({
                    message: 'Please enter a customer email'
                });
                return;
            }

            const url = `${Env.baseUrl}/v2/superadmin/reg-product/change-ownership`;
            this.spinner(true);

            try {
                const res = await AuthApis.postApi(url, {
                    customer_email: this.customer_email,
                    product_id: this.product_detail.id
                });

                this.spinner(false);
                this.$toasted.global.success({
                    message: res.data.message
                });
                this.customer_email = ''; // Clear the input after success
            } catch (err) {
                this.spinner(false);
                console.error('Error assigning ownership:', err);

                let errorMessage = 'Failed to assign ownership';
                if (err.response) {
                    if (err.response.status === 404) {
                        errorMessage = 'API endpoint not found. Please check the URL configuration.';
                    } else if (err.response.data && err.response.data.message) {
                        errorMessage = err.response.data.message;
                    }
                }

                this.$toasted.global.error({
                    message: errorMessage
                });
            }
        }
    }
};
</script>
